export enum CodingContractName {
  FindLargestPrimeFactor = "Find Largest Prime Factor",
  SubarrayWithMaximumSum = "Subarray with Maximum Sum",
  TotalWaysToSum = "Total Ways to Sum",
  TotalWaysToSumII = "Total Ways to Sum II",
  SpiralizeMatrix = "Spiralize Matrix",
  ArrayJumpingGame = "Array Jumping Game",
  ArrayJumpingGameII = "Array Jumping Game II",
  MergeOverlappingIntervals = "Merge Overlapping Intervals",
  GenerateIPAddresses = "Generate IP Addresses",
  AlgorithmicStockTraderI = "Algorithmic Stock Trader I",
  AlgorithmicStockTraderII = "Algorithmic Stock Trader II",
  AlgorithmicStockTraderIII = "Algorithmic Stock Trader III",
  AlgorithmicStockTraderIV = "Algorithmic Stock Trader IV",
  MinimumPathSumInATriangle = "Minimum Path Sum in a Triangle",
  UniquePathsInAGridI = "Unique Paths in a Grid I",
  UniquePathsInAGridII = "Unique Paths in a Grid II",
  ShortestPathInAGrid = "Shortest Path in a Grid",
  SanitizeParenthesesInExpression = "Sanitize Parentheses in Expression",
  FindAllValidMathExpressions = "Find All Valid Math Expressions",
  HammingCodesIntegerToEncodedBinary = "HammingCodes: Integer to Encoded Binary",
  HammingCodesEncodedBinaryToInteger = "HammingCodes: Encoded Binary to Integer",
  Proper2ColoringOfAGraph = "Proper 2-Coloring of a Graph",
  CompressionIRLECompression = "Compression I: RLE Compression",
  CompressionIILZDecompression = "Compression II: LZ Decompression",
  CompressionIIILZCompression = "Compression III: LZ Compression",
  EncryptionICaesarCipher = "Encryption I: Caesar Cipher",
  EncryptionIIVigenereCipher = "Encryption II: Vigenère Cipher",
  SquareRoot = "Square Root",
  TotalPrimesInRange = "Total Number of Primes",
  LargestRectangleInAMatrix = "Largest Rectangle in a Matrix",
}
